export const useLogout = async () => {
  const { accountAPI } = useBackendRequests();
  const isAuthenticated = useAuthState();
  const accountStore = useAccountStore();

  await accountAPI.logout();
  isAuthenticated.value = false;
  accountStore.clear();
};
